export default __webpack_public_path__ + "static/media/1.0bd6d723.jpg";